import { useMemo } from "react";

import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { Address } from "@/Common/Models/Contacts/Address";
import { FilteredOrganizationRules } from "@/Common/Utilities/FilteredOrganizationRules";

/**
 * Returns the filtered organization rules based on the address provided and licence organization rule and preferred address.
 * @param userLicenceOrganizationRule The user's associated licence organization rule
 * @param preferredAddress Address optional
 * @param filter Optional filter to apply to the organization rules
 * @returns The Licence Organization Rules associated with the address's country and state lookup id.
 */
export const useFilteredOrganizationRules = (
    userLicenceOrganizationRule: LicenceOrganisationRule,
    preferredAddress?: Address,
    filter?: (organizationRule: LicenceOrganisationRule) => boolean,
    includeInactiveRules: boolean = false
): FilteredOrganizationRules => useMemo(
    () => new FilteredOrganizationRules(cacheStore.getFilteredOrganizationRulesParam(filter))
        .createLicenceOrganizationRulesByCountryAndState(
            userLicenceOrganizationRule,
            preferredAddress?.CountryLookupId,
            preferredAddress?.StateLookupId,
            includeInactiveRules
        ),
    [preferredAddress?.CountryLookupId, preferredAddress?.StateLookupId, userLicenceOrganizationRule, filter, includeInactiveRules]
);
